import { StyleProp, ViewStyle } from 'react-native';
import { SharedValue } from 'react-native-reanimated';

import { PrismicTypeWithData } from '@/types/prismic';
import { PromotionDocument, PromotionThemeDocument } from '@/types/prismic.generated';

export interface CircleTopGlowProps {
    color: string;
    cx?: number;
    cy?: number;
    opacity?: number;
    radius?: number;
    blur?: number;
    headerHeight?: SharedValue<number>;
    style?: StyleProp<ViewStyle>;
}

export type PromotionWithTheme = PrismicTypeWithData<
    PromotionDocument,
    {
        promo_theme: PromotionThemeDocument;
    }
>;

export enum PromoStatus {
    ACTIVE = 'ACTIVE',
    OPTED_IN = 'OPTED_IN',
    PENDING = 'PENDING',
    AWARDED = 'AWARDED',
    FAILED = 'FAILED',
    EXPIRED = 'EXPIRED',
    AVAILABLE = 'AVAILABLE',
}

export enum ProgressStatus {
    ACTIVE = 'ACTIVE',
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
}

export type BonusEnginePromo = {
    promoSlug: string;
    optInRequired: boolean;
    // optInTime is also used as a flag to know if the user opted in or not
    optedInTime?: string;
    expirationTime: string;
    qualCriteria: string;
    id: string;
};
export type DepositMatchPromo = {
    slug: string;
    expirationTime: string;
    maxAmount: number;
    percentage: number;
};

export type GenericPromo = {
    accountId: string;
    createdTime: string;
    gameId: string;
    status: PromoStatus;
};

export type ProgressStep = {
    status: ProgressStatus;
    stepId: string;
    title: string;
};

export type PromoProgress = {
    currentAmount: number;
    description: string;
    hasOptedIn: boolean;
    productId: string;
    promotionId: string;
    rewardAmount: number;
    showPromotion: boolean;
    status: ProgressStatus | null;
    targetAmount: number;
    title: string;
    steps: ProgressStep[];
};

export type Promotion = PromotionWithTheme & {
    bonusEngineDetails?: BonusEnginePromo;
    optedIn: boolean;
};
